import { type Accessor, Show } from "solid-js";
import type { BoardItemListItemResponse } from "@/client";
import type { VideoEvidence } from "~/modules/shared/chat/ChatEventTypes";
import "./video-panel.css";
import { VideoPanelCarousel } from "~/modules/shared/chat/components/VideoPanelContent/VideoPanelCarousel/VideoPanelCarousel";

type Props = {
	boardId: string;
	isMounted: Accessor<boolean>;
	isOpen: Accessor<boolean>;
	isClosing: Accessor<boolean>;
	layoutAnimating: Accessor<boolean>;
	onToggle: () => void;
	onEditClip?: (clipId: string) => void;
	onVideoIndexChange: (index: number) => void;
	videoEvidence: VideoEvidence[];
	clip: BoardItemListItemResponse;
	videoIndex: Accessor<number | undefined>;
	carouselInstantJumpToken: Accessor<number>;
};

export const PlayPanel = (props: Props) => {
	return (
		<Show
			when={
				props.isMounted() &&
				props.videoIndex() !== undefined &&
				props.videoEvidence[props.videoIndex() ?? -1]
			}
		>
			<div
				class="board-play-panel"
				classList={{
					"board-play-panel--open": props.isOpen(),
					"board-play-panel--closing": props.isClosing(),
					"board-play-panel--animating": props.layoutAnimating(),
				}}
			>
				<div class="board-play-panel__content">
					<div
						class="board-play-panel__video-content"
						style={{ padding: "1rem" }}
					>
						<VideoPanelCarousel
							activeSlide={props.videoIndex() ?? 0}
							setActiveSlide={props.onVideoIndexChange}
							videoEvidence={props.videoEvidence}
							boardId={props.boardId}
							onClose={props.onToggle}
							onEditClip={props.onEditClip}
							showAddToBoardButton={false}
							instantJumpToken={props.carouselInstantJumpToken()}
							autoPlay={false}
						/>
					</div>
				</div>
			</div>
		</Show>
	);
};
